<script setup lang="ts">
import type { Props } from 'nuxt-base/components/InputLexicalTextBase.vue'

const props = defineProps<Props & { ui?: 'border' | 'chat' | 'return' }>()
const elem = useTemplateRef('elem')
defineExpose({
  ...myInputPass(() => elem),
  reset: () => elem.value?.reset(),
})

const focus = shallowRef(false)
</script>

<template>
  <InputLexicalTextBase
    ref="elem"
    v-bind="props"
    :class="[ui === 'border' && $style.border, ui === 'chat' && $style.chat, ui === 'return' && $style.return, { optional, focus }]"
    :class-editor="[$style.editor, '_pl14 _pr14', ui === 'return' ? '_hm100 _pt2 _pb2' : ui === 'chat' ? '_pt2 _pb2' : undefined]"
    :class-label="ui ? '_pl14 _pr14' : undefined"
    :focused="(i) => focus = i"
  ><slot /></InputLexicalTextBase>
</template>

<style module>
.border {
  composes: global(_w70ch);
  composes: global(_br14);
  composes: global(_b5);
}
.border:global(.optional) {
  border-style: dashed;
}

.border:global(.focus) {
  background: var(--bg);
  outline-color: rgba(16, 124, 136, 0.1);
  box-shadow: 0 0 0 3px var(--blue8);
  border-color: var(--blue7);
}

.chat {
  composes: global(_w100p);
  composes: global(_flex);
  align-self: stretch;
}

.return {
  background: var(--black-6);
  composes: global(_br14);
}
</style>
